import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";

import { t } from "i18next";

import { authUserData } from "../../utils/Helper";

// import { useTranslation } from "react-i18next";

import TransactionListCompany from "./TransactionListCompany";

import AddMoneyModelAdmin from "./AddMoneyModelAdmin";
// import AddMoneyModelCompany from "./AddMoneyModelCompany";
function WalletCompany() {
  const walletId = authUserData()?.wallet_id ? authUserData()?.wallet_id : "";
  const CompanyId = authUserData()?.company ? authUserData()?.company : "";
  const CompanyType = authUserData()?.company_type
    ? authUserData()?.company_type
    : "";
  const CompanyWalletBalance = authUserData()?.company_balance
    ? authUserData()?.company_balance
    : 0.0;
  const CompanyCreditDue = authUserData()?.company_credit_due
    ? authUserData()?.company_credit_due
    : 0.0;
  const CompanyInvoiceDueDays = authUserData()?.company_invoice_due_days
    ? authUserData()?.company_invoice_due_days
    : 0;

  // const [reload, setReload] = useState(false);
  // const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [modalKey, setModalKey] = useState(false);
  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  }, []);

  // const [invoiceRequested, setInvoiceRequested] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleAddMoney = (id) => {
    setModalKey((prevKey) => !prevKey);
    showModal();
  };

  // const handleRequestInvoice = () => {
  //   // Your logic to request invoice goes here (e.g., API call)
  //   setInvoiceRequested(true); // change button state after request
  // };

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  // route list

  return (
    <>
      <div className="layout-content">
        <div className="creditdue">
          <div className="walletdue">
            <span className="material-symbols-outlined">
              account_balance_wallet
            </span>
            <label>
              {CompanyType === "Pre Paid" ? "Wallet Balance" : "Credit Due"} :
            </label>
            {CompanyType === "Pre Paid"
              ? CompanyWalletBalance
              : CompanyCreditDue}
          </div>

          {CompanyType === "Pre Paid" && (
            <Button
              type="primary"
              className="SaveGradiantBtnRecharge"
              icon={
                <span
                  className="material-symbols-outlined"
                  style={{
                    verticalAlign: "middle",
                  }}
                >
                  add
                </span>
              }
              onClick={handleAddMoney}
            >
              Add Recharge
            </Button>
          )}
          {/* {(CompanyInvoiceDueDays === 0 || CompanyInvoiceDueDays === null) &&
          CompanyType === "Post Paid" ? (
            <>
              <Tooltip title="Invoice is being processed. You’ll receive an email once ready.">
                <div style={{ display: "inline-block" }}>
                  <Button
                    type="primary"
                    className="SaveGradiantBtnRecharge"
                    disabled={invoiceRequested}
                    icon={
                      <span
                        className="material-symbols-outlined"
                        style={{ verticalAlign: "middle" }}
                      >
                        {invoiceRequested ? "order_approve" : "assignment_add"}
                      </span>
                    }
                    onClick={handleRequestInvoice}
                  >
                    {invoiceRequested ? "Invoice Requested" : "Request Invoice"}
                  </Button>
                </div>
              </Tooltip>
            </>
          ) : (
            ""
          )} */}
          {CompanyType === "Post Paid" ? (
            CompanyInvoiceDueDays !== 0 && CompanyInvoiceDueDays !== null ? (
              <div className="walletdue">
                <span className="material-symbols-outlined">
                  assignment_add
                </span>
                <label>
                  {CompanyType === "Post Paid"
                    ? "Company Invoice Due Days"
                    : ""}
                </label>
                {CompanyType === "Post Paid" && CompanyInvoiceDueDays}
              </div>
            ) : (
              <div className="walletdue">
                <span className="material-symbols-outlined">order_approve</span>
                <label>No invoice pending</label>
              </div>
            )
          ) : (
            ""
          )}
        </div>
        <section className="grid-sec">
          {/* Transaction list */}

          <TransactionListCompany />

          {/* <Modal
            className="ModelPopupSec"
            title={t("Add Wallet Recharge")}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            closable={false}
            wrapClassName="modal-wrapper"
            keyboard={false}
          >
            <AddMoneyModelCompany
              handleCancel={handleCancel}
              setReload={setReload}
              walletId={walletId}
              // modalKey={modalKey}
              setStateM={setState}
            />
          </Modal> */}
          <Modal
            className="ModelPopupSecAddRecharge"
            centered
            title={t("Add Wallet Recharge")}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            closable={false}
            wrapClassName="modal-wrapper"
            keyboard={false}
            width={1000}
          >
            <AddMoneyModelAdmin
              handleCancel={handleCancel}
              // setReload={setReload}
              walletId={walletId}
              companyId={CompanyId}
              modalKey={modalKey}
              setStateM={setState}
            />
          </Modal>
        </section>
      </div>
    </>
  );
}

export default WalletCompany;
